import { defineComponent, ref, onMounted, onUnmounted, createElementBlock, openBlock, createElementVNode, normalizeStyle, toDisplayString, createCommentVNode, Fragment, renderList, normalizeClass, createVNode, createTextVNode } from 'vue';
import _sfc_main$1 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = { class: "payment-info" };
const _hoisted_2 = { class: "payment-info__label" };
const _hoisted_3 = ["src", "alt"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PaymentInfo",
  props: {
    paymentIcons: { default: () => [] },
    label: { default: "Secure Payment" },
    showExtendedDetails: { type: Boolean, default: false },
    extendedDetailsIcon: { default: "certify" },
    extendedDetailsText: { default: "100 Tage Rückgabe" },
    backgroundColor: { default: "#ffffff" }
  },
  setup(__props) {
    const iconsRef = ref(null);
    const detailsRef = ref(null);
    const isWrapped = ref(false);
    const checkWrapping = () => {
      if (!iconsRef.value || !detailsRef.value) return;
      const iconsRect = iconsRef.value.getBoundingClientRect();
      const detailsRect = detailsRef.value.getBoundingClientRect();
      isWrapped.value = detailsRect.top > iconsRect.top + 10;
    };
    let resizeObserver = null;
    onMounted(() => {
      checkWrapping();
      if (iconsRef.value && detailsRef.value) {
        resizeObserver = new ResizeObserver(() => {
          checkWrapping();
        });
        resizeObserver.observe(iconsRef.value.parentElement);
      }
      window.addEventListener("resize", checkWrapping);
    });
    onUnmounted(() => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", checkWrapping);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("div", {
          class: "payment-info__inner",
          style: normalizeStyle({ "--background-color": _ctx.backgroundColor })
        }, [
          createElementVNode("span", _hoisted_2, toDisplayString(_ctx.label), 1),
          createElementVNode("div", {
            ref_key: "iconsRef",
            ref: iconsRef,
            class: "payment-info__icons"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.paymentIcons, (icon) => {
              return openBlock(), createElementBlock("div", {
                key: icon.src,
                class: "payment-info__icon-item"
              }, [
                createElementVNode("img", {
                  src: icon.src,
                  alt: icon.alt
                }, null, 8, _hoisted_3)
              ]);
            }), 128)),
            _ctx.showExtendedDetails ? (openBlock(), createElementBlock("div", {
              key: 0,
              ref_key: "detailsRef",
              ref: detailsRef,
              class: normalizeClass(["payment-info__details", { "payment-info__details--wrapped": isWrapped.value }])
            }, [
              createVNode(_sfc_main$1, {
                name: _ctx.extendedDetailsIcon,
                size: "medium"
              }, null, 8, ["name"]),
              createTextVNode(" " + toDisplayString(_ctx.extendedDetailsText), 1)
            ], 2)) : createCommentVNode("", true)
          ], 512)
        ], 4)
      ]);
    };
  }
});

export { _sfc_main as default };
